import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import Footer from './components/Footer'
import animated from 'animate.css'
import Bread from './components/BreadCrumb'
import BaiduMap from 'vue-baidu-map'

// import vueJsonp from 'vue-jsonp'
// Vue.use(vueJsonp)

Vue.use(BaiduMap, {
  /* 申请的百度密钥，可以在百度地图官网申请 */
  ak: 'YvGqYGPgiMf13sYzzffb1PPHd7MXe22d'
})
Vue.use(Bread)
Vue.use(Footer)
Vue.use(animated)
Vue.use(ElementUI)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
